/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Tooltip_Techsource1Inputs */

const id_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami menggunakan`)
};

const ms_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami menggunakan`)
};

const da_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi bruger`)
};

const de_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir verwenden`)
};

const en_us2_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We use the`)
};

const es_es2_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usamos la`)
};

const es_mx2_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usamos`)
};

const fil_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginagamit namin ang`)
};

const fr_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous utilisons`)
};

const it_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usiamo`)
};

const hu_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Használjuk a`)
};

const nl_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We gebruiken`)
};

const no_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi bruker`)
};

const pl_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korzystamy z`)
};

const pt_br2_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nós usamos o`)
};

const pt_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizamos a`)
};

const ro_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folosim`)
};

const fi_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käytämme`)
};

const sv_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi använder`)
};

const vi_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chúng tôi sử dụng`)
};

const tr_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şunu kullanıyoruz:`)
};

const cs_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Používáme`)
};

const bg_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Използваме`)
};

const ru_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы используем`)
};

const uk_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ми використовуємо`)
};

const ar_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نستخدم`)
};

const hi_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हम उपयोग करते हैं`)
};

const th_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เราใช้`)
};

const ja_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用元：`)
};

const zh_cn2_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们使用`)
};

const zh_hant1_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們使用`)
};

const ko_builds_tooltip_techsource1 = /** @type {(inputs: Builds_Tooltip_Techsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음을 사용합니다`)
};

/**
* | output |
* | --- |
* | "We use the" |
*
* @param {Builds_Tooltip_Techsource1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_tooltip_techsource1 = /** @type {((inputs?: Builds_Tooltip_Techsource1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Tooltip_Techsource1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_tooltip_techsource1(inputs)
	if (locale === "ms") return ms_builds_tooltip_techsource1(inputs)
	if (locale === "da") return da_builds_tooltip_techsource1(inputs)
	if (locale === "de") return de_builds_tooltip_techsource1(inputs)
	if (locale === "en-US") return en_us2_builds_tooltip_techsource1(inputs)
	if (locale === "es-ES") return es_es2_builds_tooltip_techsource1(inputs)
	if (locale === "es-MX") return es_mx2_builds_tooltip_techsource1(inputs)
	if (locale === "fil") return fil_builds_tooltip_techsource1(inputs)
	if (locale === "fr") return fr_builds_tooltip_techsource1(inputs)
	if (locale === "it") return it_builds_tooltip_techsource1(inputs)
	if (locale === "hu") return hu_builds_tooltip_techsource1(inputs)
	if (locale === "nl") return nl_builds_tooltip_techsource1(inputs)
	if (locale === "no") return no_builds_tooltip_techsource1(inputs)
	if (locale === "pl") return pl_builds_tooltip_techsource1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_tooltip_techsource1(inputs)
	if (locale === "pt") return pt_builds_tooltip_techsource1(inputs)
	if (locale === "ro") return ro_builds_tooltip_techsource1(inputs)
	if (locale === "fi") return fi_builds_tooltip_techsource1(inputs)
	if (locale === "sv") return sv_builds_tooltip_techsource1(inputs)
	if (locale === "vi") return vi_builds_tooltip_techsource1(inputs)
	if (locale === "tr") return tr_builds_tooltip_techsource1(inputs)
	if (locale === "cs") return cs_builds_tooltip_techsource1(inputs)
	if (locale === "bg") return bg_builds_tooltip_techsource1(inputs)
	if (locale === "ru") return ru_builds_tooltip_techsource1(inputs)
	if (locale === "uk") return uk_builds_tooltip_techsource1(inputs)
	if (locale === "ar") return ar_builds_tooltip_techsource1(inputs)
	if (locale === "hi") return hi_builds_tooltip_techsource1(inputs)
	if (locale === "th") return th_builds_tooltip_techsource1(inputs)
	if (locale === "ja") return ja_builds_tooltip_techsource1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_tooltip_techsource1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_tooltip_techsource1(inputs)
	return ko_builds_tooltip_techsource1(inputs)
});
export { builds_tooltip_techsource1 as "builds.tooltip.techSource" }